import type { FaireProductEntity } from "../../entity_types/product";

export const p_225q3pgfxf: FaireProductEntity = {
  token: "p_225q3pgfxf",
  type: "product",
  name: "CWSJS0720_SOLID COLOR CASUAL LOOSE POCKET JUMPSUIT",
  brandToken: "b_gd86yguu29",
  brandName: "NINEXIS",
  imageUrl:
    "https://cdn.faire.com/fastly/ff2ce56d877cc79e7e44398dd2d44928dcc512a754e20da0e0d5d7b654efcfa1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53c13f1bb8e9a64c067bcd0433c1a00929dad2aa8e753b69c5b89aac8a3b59c8.jpeg",
    "https://cdn.faire.com/fastly/e80ceb4cc70bad824176f7eab0d004073bcd10b71abf8fc9f8c7b277c2286196.jpeg",
    "https://cdn.faire.com/fastly/990cf95265524e013f202668a778ba8e373d861b34455d4e272d44f8c8bf8fbf.jpeg",
    "https://cdn.faire.com/fastly/b6cfe49c796d3a05d10b4a6f7567f8b1f17c51bba1d05dad5e58c11ab625e753.jpeg",
    "https://cdn.faire.com/fastly/36cda8d36b99490f2bc11a6977e4ab41240e47ab825f773f43a61347795b147e.jpeg",
    "https://cdn.faire.com/fastly/83227a9f4c946ff3048e0f6409a5bc5dc03df2bfc47b1fa86aa70a1d7dd3af8b.jpeg",
    "https://cdn.faire.com/fastly/71deb3e018306184d35363f9a7d144e38dcd3cd8367b36dc2141278b8adb9541.jpeg",
    "https://cdn.faire.com/fastly/0fd6878206f31231125c990892482c08162f73c0b25f06ad2e125b0145568544.jpeg",
    "https://cdn.faire.com/fastly/6df8d64b8a985576ec49ec332dded9f9819f35d490d3e846e7a7fac854ef1c76.jpeg",
    "https://cdn.faire.com/fastly/55dd8b3974c5f1ecdfd07f917ef4d36ce2881c1fefc90687de53bb804d2f8e10.jpeg",
    "https://cdn.faire.com/fastly/3e29331b21f056dea8f3443579983748f97f7fdc0815ef39d06d68d91f58a595.jpeg",
    "https://cdn.faire.com/fastly/890a8d04a6d20025e4d7a35a8801dbc91ba78b80a2a644d79890cc2bcd1e2334.jpeg",
    "https://cdn.faire.com/fastly/16581adf2b0c0a1a4ba87811594d0e97a88da285894f7abc2c093785b8e36baf.jpeg",
    "https://cdn.faire.com/fastly/bd04c417480e206d2f5061e103af35980d8c4df849de60e15f82ef63588564f1.jpeg",
    "https://cdn.faire.com/fastly/e6349691860f65eb25e1d52a025dd41fdf2db8a2577c30d7518216ea598261f8.jpeg",
    "https://cdn.faire.com/fastly/5320bf8e4e9db264427d698b1a8865064820c3e4a61ca5b8359f364b5693f680.jpeg",
    "https://cdn.faire.com/fastly/e642592c745169882798cba1dcc0e37a0db186623465cec45f28329bd62c175b.jpeg",
    "https://cdn.faire.com/fastly/17945575e1becfc2c5318989eead6db092474fffe695c700262bbeb50ead5182.jpeg",
    "https://cdn.faire.com/fastly/c9d776d3f013f40db50b0c19571cfc986b53a6120c11f0425b798c4f2189bb71.jpeg",
    "https://cdn.faire.com/fastly/0aa790f8da3400cea5ce8bdc2b0511725f8730afb08c566e482d793971fe2768.jpeg",
    "https://cdn.faire.com/fastly/f37efd52cdcbb2544ca8de0d962b18137602ec51ce2967bc2adf9aba39253409.jpeg",
    "https://cdn.faire.com/fastly/cb0102d074a9f9da3bd2903d9c3b575ffc0ca1bf482be0d5b1c2d2536db997b3.jpeg",
    "https://cdn.faire.com/fastly/200bf92d90e4f8602ea12fe59b5520cfa1081467548bd02f312e2b2dd13f3f8f.jpeg",
  ],
  priceDollars: 17.95,
  description:
    "SOLID COLOR CASUAL LOOSE POCKET JUMPSUIT\n95% POLYESTER, 5% SPANDEX\nSIZE  S/M/L/XL/2XL\nMADE IN CHINA\n\nWOMEN JUMPSUITS, JUMPSUITS,ROMPERS WITH POCKET,WOMEN ROMPERS,SPORT JUMPSUITS,SUMMER JUMPSUITS,JUMPSUITS FOR WOMEN DRESSY,ROMPERS FOR WOMEN,JUMPSUITS FOR WOMEN CASUAL,JUMPSUITS FOR WOMEN SHORTS,JUMPSUITS FOR WOMEN SEXY,JUMPSUITS FOR WOMEN SUMMER,FLARE JUMPSUITS,PLUS SIZE ROMPERS,SHORT JUMPSUITS,PRINTED JUMPSUITS,FLORAL JUMPSUITS,BOHO JUMPSUITS, WEDDING ROMPERS,2024 WOMEN ROMPERS",
  tags: [],
  msrpDollars: 35.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:50.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
